import { useState } from "react";
import { Link,useLocation  } from "react-router-dom";

const Header = () => {
  const [openMenu, setOpenMenu] = useState(false);

  const menu = [
    { name: "Home", path: "/" },
    { name: "Demo", path: "/demo" },
    { name: "Coverage ", path: "/coverage" },
    { name: "About Us ", path: "/about" },
    { name: "Contact Us ", path: "/contact" },
  ];
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <header className="mb-6">
      <div className= {`container max-w-7xl mx-auto border-b-2 px-5 ${openMenu && "fixed z-10"}`}>
        <div className="h-20 flex justify-between items-center">
          <Link className="flex items-center" to="/">
            <img src="/images/logo.svg" className="h-12" alt="logo" />
            <span className="inline-block bg-[#000] text-white text-[11px] p-[1px] px-[4px] rounded-[4px] relative -top-[10px] font-normal ml-1">BETA</span>
          </Link>
          <nav className="items-center gap-10 h-full hidden md:flex">
            {menu.map((item) => (
              <Link
                to={item.path}
                key={item.name}
                className={`px-2 py-3 font-medium ${
                  (currentPath === item.path || (currentPath === '/detail' && item.path === '/demo')) 
                    ? "text-gradient"
                    : "text-[#000000]"
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>
          <div className="md:hidden">
            <button
              className={`block hamburger md:hidden focus:outline-none z-40 ${
                openMenu && "open"
              }`}
              onClick={() => setOpenMenu(!openMenu)}
            >
              <span className="hamburger-top"></span>
              <span className="hamburger-middle"></span>
              <span className="hamburger-bottom"></span>
            </button>
          </div>
          <nav
            className={`items-center md:hidden fixed z-10 top-0 left-0 w-full bg-white flex flex-col pt-20 min-h-screen gap-5 ${
              !openMenu && "hidden"
            }`}
          >
            {menu.map((item) => (
              <Link
              onClick={() => setOpenMenu(false)}
                to={item.path}
                key={item.name}
                className="block px-2 py-3 font-medium"
              >
                {item.name}
              </Link>
            ))}
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
